import Plotly from 'plotly.js';
import React from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
export const Chart = (data) => {
  const Plot = createPlotlyComponent(Plotly);

  return (
    <Plot
      key={data?.layout?.title?.text}
      data={data?.data}
      layout={data?.layout}
      config={{ responsive: true }}
    />
  );
};
